import { IId, IName } from 'interfaces/common/common';

import { client } from '@api/client';

import { IOperationWindowRulesDTO, TOperationWindowRuleDTO, TOperationWindowRulesDeleteManyDTO } from '@interfaces/cmModule/dto/operationWindowRulesDTO';
import { IOperationWindowRule } from '@interfaces/cmModule/operationWindowRules';
import { IItemsResponse } from '@interfaces/common/response';
import { INote } from '@interfaces/networkElements/networkElements';

import { URL } from './urls';

const {
	operationWindowRules,
	configurationConsistency,
} = URL;

export const getOperationWindowRules = (
	params: IOperationWindowRulesDTO,
): Promise<IItemsResponse<IOperationWindowRule>> => {
	return client.get(`${configurationConsistency}/${operationWindowRules}`, { params });
};

export const getOperationWindowRuleNote = ({ id }: IId): Promise<IItemsResponse<IOperationWindowRule>> => {
	return client.get(`${configurationConsistency}/${operationWindowRules}/${id}/note`);
};

export const checkOperationWindowRuleName = (dto: IName): Promise<void> => {
	return client.post(`${configurationConsistency}/${operationWindowRules}/check-unique-name`, dto);
};

export const updateOperationWindowRuleNote = ({ id, ...dto }: IId & INote): Promise<void> => {
	return client.post(`${configurationConsistency}/${operationWindowRules}/${id}/update-note`, dto);
};

export const createOperationWindowRule = (dto: IOperationWindowRulesDTO): Promise<void> => {
	return client.post(`${configurationConsistency}/${operationWindowRules}/create`, dto);
};

export const updateOperationWindowRule = ({ id, ...dto }: IId & TOperationWindowRuleDTO): Promise<void> => {
	return client.post(`${configurationConsistency}/${operationWindowRules}/${id}/update`, dto);
};

export const deleteOperationWindowRule = ({ id }: IId): Promise<void> => {
	return client.delete(`${configurationConsistency}/${operationWindowRules}/${id}/delete`);
};

export const deleteOperationWindowRules = (dto: TOperationWindowRulesDeleteManyDTO): Promise<void> => {
	return client.post(`${configurationConsistency}/${operationWindowRules}/delete-many`, dto);
};

